import { DateEntry } from './DateEntry';
import { computeNameOfMonth } from '@Functions/DateFunctions'

export class MonthEntry {

  
    month: number;
    year: number;
    key: string;
    days!: Array<DateEntry>;
    monthName: string;

    constructor(month: number, year: number) {

      
        this.month = month;
        this.year = year;
        this.key = `${year}-${month}`;
        this.monthName = computeNameOfMonth(this.month);
    }

   
}
